import { Card, CardMedia, CardText } from "material-ui/Card";
import Flex from "app/components/UI/Flex";
import PropTypes from "prop-types";
import React from "react";
import classes from "./CardItem.module.css";
import logo from "../../Header/logo.png";

export const CardItem = ({ title, subtitle, right, mediaUrl, mediaName }) => (
  <Card className={classes.card} zDepth={1}>
    <CardMedia className={classes.card__media} style={{ background: "#FAFAFA" }}>
      {mediaUrl ? (
        <img src={mediaUrl} alt={mediaName} />
      ) : (
        <img src={logo} className={classes.card__media__noImage} alt="Bluegreen Logo" />
      )}
    </CardMedia>

    <div>
      <CardText className={classes.card__content}>
        <Flex size={1} direction="column" className={classes.card__left}>
          <div className={classes.card__title}> {title}</div>
          {subtitle && (
            <div className={classes.card__subtitle} title={subtitle}>
              {subtitle}
            </div>
          )}
        </Flex>

        {right && <Flex className={classes.card__right}>{right}</Flex>}
      </CardText>
    </div>
  </Card>
);

CardItem.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.node,
  mediaUrl: PropTypes.string,
  mediaName: PropTypes.string,
  right: PropTypes.node
};

export default CardItem;



// WEBPACK FOOTER //
// ./src/app/components/UI/CardItem/CardItem.js